import React from 'react';
import BackIcon from '../svg/BackIcon';
import { Link } from 'react-router-dom';
import { Brands } from '../../../models/brands';
import { BrandStyling } from '../../../theme/brandStyling';

type AppHeaderProps = {
    isBackIconShown?: boolean;
    redirectTo?: string;
    className?: string;
    brandId?: Brands;
};

const AppHeader: React.FC<AppHeaderProps> = ({
    isBackIconShown = false,
    redirectTo,
    className = '',
    brandId = Brands.URocked,
}) => {
    const styling = BrandStyling.byBrand(brandId);
    return (
        <div
            className={`flex items-center h-14 z-10 py-2 px-5 ${className} ${styling.header} ${
                isBackIconShown ? 'justify-between' : 'justify-end'
            }`}
        >
            {isBackIconShown && (
                <Link to={`${redirectTo ? redirectTo : '/'}`}>
                    <BackIcon className="ml-5 mr-5 mt-4 mb-4" brandId={brandId}/>
                </Link>
            )}
            {
                styling.logo
            }
        </div>
    );
};

export default AppHeader;
